import { WebChatBotConversationModel } from "@jugl-web/rest-api";
import { CHAT_MESSAGE_PAYLOAD_VERSION } from "@jugl-web/utils/consts";
import { ChatListItem } from "@web-src/modules/chats/components/ChatListItem";
import { ChatListItemLastMessage } from "@web-src/modules/chats/components/ChatListItemLastMessage";
import { tokenizeMessageBody } from "@web-src/modules/chats/utils";
import React, { useMemo } from "react";
import { useClientSupportPageContext } from "../../../../providers/ClientSupportPageProvider/useClientSupportPageContext";
import { WebChatAvatar } from "../../../WebChatAvatar";
import { CRMAgentInfo } from "../CRMAgentInfo";

export const WebConversationTile: React.FC<{
  conversation: WebChatBotConversationModel;
  searchQuery?: string;
}> = ({ conversation, searchQuery }) => {
  const { selectedConversation, selectConversation } =
    useClientSupportPageContext();

  const lastMessageBody = useMemo(
    () => conversation.payload.text || "",
    [conversation]
  );

  return (
    <ChatListItem
      chatId={conversation.conv_id}
      img={
        <WebChatAvatar
          conversationName={
            conversation.contact_info?.name || conversation.name
          }
          size="lg"
        />
      }
      onClick={() => selectConversation(conversation)}
      isSelected={selectedConversation?.conv_id === conversation.conv_id}
      title={conversation.contact_info?.name || conversation.name}
      timestamp={conversation.inserted_at}
      lastMessageContent={
        <ChatListItemLastMessage
          payloadVersion={CHAT_MESSAGE_PAYLOAD_VERSION}
          tokenizedMessage={tokenizeMessageBody(lastMessageBody)}
        />
      }
      additionalContent={<CRMAgentInfo conversation={conversation} />}
      showUnreadIndicator={conversation.type === "incoming"}
      searchQuery={searchQuery}
      hasChatAccess
    />
  );
};
